// extracted by mini-css-extract-plugin
export default {"wrapper":"AnalyticsTab_wrapper__m1jgg","header":"AnalyticsTab_header__Z7HbP","content":"AnalyticsTab_content__nix80"};